import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
const styles = {
  label: {
    cursor: 'pointer'
  }
};
const TextIcon = props => {
  let children;
  const index = props.index,
    rowData = props.rowData;
  const iconClickHandler = () => {
    if (props.onIconClick && typeof props.onIconClick === 'function') {
      props.onIconClick({
        index,
        rowData
      });
    }
  };
  const getIconDiv = iconObj => {
    return iconObj != null && /*#__PURE__*/React.createElement("div", {
      onClick: () => iconClickHandler(),
      className: "".concat(props.classes.label)
    }, iconObj);
  };
  const content = typeof props.children === 'string' ? props.children : '';
  let defaultToPostfix = !props.prefix && !props.postfix;
  let iconComponent = props.icon ? typeof props.icon === 'function' ? props.icon({
    index,
    rowData
  }) : typeof props.icon === 'object' ? props.icon : null : null;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row'
    },
    "data-testid": "texticon-div"
  }, props.prefix && getIconDiv(iconComponent), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
    className: "".concat(props.classes.label),
    title: content,
    "data-test": props.testClass,
    style: {
      paddingRight: 10
    },
    "data-testid": "textLabel"
  }, content)), (defaultToPostfix || props.postfix) && getIconDiv(iconComponent));
};
export default withStyles(styles)(TextIcon);